export default __webpack_public_path__ + "static/media/received_862700541147322.f4b1722f.jpeg";